/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import Constants from '@/utils/Constants';
import logoutUtil from '@/utils/LogoutUtil';
// Routes
import routes from './routes';

// Policy
import {
  PUBLIC_PAGES,
  JUST_LOGIN_PAGES,
  includesString,
} from './policy';

Vue.use(VueRouter);
const storage = window.localStorage;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['user/isLoggedIn'];

  // is public: go ahead
  const isPublic = includesString(PUBLIC_PAGES, to.path);
  if (isPublic || to.path === '/timeout' || to.path === '/invalidauth') {
    return next();
  }
  // debugger;
  // not public and not logged in: redirect to login
  if (!isLoggedIn || typeof to.query.Authorization !== 'undefined') {
    let pathValue;
    if (process.env.VUE_APP_ENV === 'production') pathValue = '/login';
    else if (process.env.VUE_APP_ENV === 'development'
      || process.env.VUE_APP_ENV === 'local') pathValue = '/loginstg';
    return next({
      path: pathValue,
      // Store the path to redirect the user to after login
      query: { redirect: '/', Authorization: to.query.Authorization },
    });
  }
  // not public and logged in: check if page needs just login
  const isJustLogin = includesString(JUST_LOGIN_PAGES, to.path);
  if (isJustLogin) {
    // just login pages do not need agreement
    return next();
  }
  // not public and logged in and agreed: just go ahead
  return next();
});

export default router;
